import api from './api';

const eventService = {
    getAll: async ({ forceRefresh = false } = {}) => {
        const response = await api.get('/events', forceRefresh ? { cache: false } : { cacheTTL: 60 * 1000 });
        return response.data;
    },

    getById: async (id) => {
        const response = await api.get(`/events/${id}`, { cacheTTL: 60 * 1000 });
        return response.data;
    },

    create: async (eventData) => {
        const response = await api.post('/events', eventData);
        return response.data;
    },

    update: async (id, eventData) => {
        const response = await api.put(`/events/${id}`, eventData);
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/events/${id}`);
        return response.data;
    }
};

export { eventService }; 